import React, { useEffect } from 'react';
import { useGetPaymentInfo } from 'Core/hooks/platform/useGetPaymentInfo';
import Loader from 'Core/components/Loader';
import { useTranslation } from 'react-i18next';
import { platformPaths } from 'Core/config/platformConfig';
import { useNavigate } from 'react-location';

export function Platform() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: { data: { provider } = {} } = {} } = useGetPaymentInfo();


  useEffect(() => {
    if (provider) {
      const providerLower = provider.toLowerCase();
      if (providerLower === 'easy_credit') {
        navigate({ to: platformPaths.EASY_CREDIT, search: true, replace: true });
      }
    }
  }, [navigate, provider]);

  return <Loader message={t('status.loading')} />;
}
